import { monitoring } from '../../monitoring/monitoring';

export type Interaction = 'search' | 'pagination' | 'category-switch' | '';

export type Monitoring = typeof monitoring;

export class MonitoringStore {
  private activeInteraction: Interaction = '';
  public logger: Monitoring = monitoring;

  reportAppLoaded() {
    this.logger.appLoaded();
  }

  startSearchInteraction() {
    this.activeInteraction = 'search';
    this.logger.interactionStarted(this.activeInteraction);
  }

  startPaginationInteraction() {
    this.activeInteraction = 'pagination';
    this.logger.interactionStarted(this.activeInteraction);
  }

  startCategoryInteraction() {
    this.activeInteraction = 'category-switch';
    this.logger.interactionStarted(this.activeInteraction);
  }

  stopActiveInteraction() {
    if (this.activeInteraction) {
      this.logger.interactionEnded(this.activeInteraction);
      this.activeInteraction = '';
    }
  }

  getActiveInteraction() {
    return this.activeInteraction;
  }
}
